import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAutoComplete, LazyInputNumber, LazySelect, LazyTabs, LazyTab, LazyDialog, LazyFileUpload, LazyMenu, LazyToast } from '#components'
const lazyGlobalComponents = [
  ["AutoComplete", LazyAutoComplete],
["InputNumber", LazyInputNumber],
["Select", LazySelect],
["Tabs", LazyTabs],
["Tab", LazyTab],
["Dialog", LazyDialog],
["FileUpload", LazyFileUpload],
["Menu", LazyMenu],
["Toast", LazyToast],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
